// src/business/services/businessDashboardService.js
import { request, ROUTES } from "../../services/api";

export const businessDashboardAPI = {
  summary: () => request({ url: ROUTES.businessDashboardSummary, method: "GET" }),
  recentProducts: () => request({ url: ROUTES.businessDashboardRecentProducts, method: "GET" }),
  inventoryHealth: () => request({ url: ROUTES.businessDashboardInventoryHealth, method: "GET" }),
  topSelling: () => request({ url: ROUTES.businessDashboardTopSelling, method: "GET" }),
};
